module.exports = __webpack_public_path__ + "img/frame_1.b5ca7e6a.png";